export default {
  BANNERS: "बैनर्स",
  BANNER: "बैनर",
};
